import React from 'react';
import PropTypes from 'prop-types';

const CreditCard = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M83.505 48.062l1.46-6.626a4.524 4.524 0 00-3.562-5.308l-12.255-2.352-39.187-7.48a4.451 4.451 0 00-5.237 3.562l-5.7 29.782a4.525 4.525 0 003.562 5.308l10.688 2.031"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.646 87.39h5.522a4.24 4.24 0 004.845-4.881l-.178-18.169V52.441a4.524 4.524 0 00-4.525-4.453H77.77l-39.828.32a4.49 4.49 0 00-4.454 4.525l.25 30.388a4.49 4.49 0 004.524 4.453l39.544-.32M35.27 60.135l58.888-.463M39.9 78.412l18.027-.143"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CreditCard.defaultProps = {
  className: '',
};

CreditCard.propTypes = {
  className: PropTypes.string,
};

export default CreditCard;
